module.exports = __webpack_public_path__ + "img/des-2.052246b0.jpg";